import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class ActivityCategory extends Base implements EntityType {
    activityCategoryId: uuid;
    name: string;
    rate?: number | null;
    scaled: boolean;
    icon?: string | null;
    relatedArea?: string | null;
    constructor(doc: typeof ActivityCategory | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            activityCategoryId: genUUID(),
            name: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "activityCategory";
        // @ts-ignore
        this.activityCategoryId = doc._activityCategoryId || doc.activityCategoryId || doc.activitycategoryid || genUUID();
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.rate = util.coalesce(util.parseFloat(doc._rate), util.parseFloat(doc.rate), util.parseFloat(doc.rate), null);
        // @ts-ignore
        this.scaled = util.defaultBoolean([doc.scaled, doc._scaled, doc.scaled, false]);
        // @ts-ignore
        this.icon = doc._icon || doc.icon || null;
        // @ts-ignore
        this.relatedArea = doc._relatedArea || doc.relatedArea || doc.relatedarea || null;
    }
    get id(): uuid { return this.activityCategoryId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for activity category"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","comment":"Associated firm"}]; }
    toLowerCase() { return this.activityCategoryId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): ActivityCategory[] {
        return [{"activityCategoryId":"ca1a6abc-2f87-4d4a-9e2a-ea36c944d0c6","name":"Administrative","relatedArea":"Administrative","icon":"BUSINESS","status":"C"},{"activityCategoryId":"a8415c01-8d32-4620-bdc1-6832c6227c25","name":"Client","relatedArea":"Client","icon":"CASE","status":"C"},{"activityCategoryId":"0bc3ad94-8786-425f-bcbc-2bad281c0ad6","name":"Financials","relatedArea":"Financials","icon":"CHART","status":"C"},{"activityCategoryId":"fabc9370-8ead-4c82-9a4d-a37f9a692d92","name":"Human Resources","relatedArea":"Human Resources","icon":"USER","status":"C"},{"activityCategoryId":"038bd87f-2d35-431e-b5c8-7a31cf31a9f6","name":"Marketing","relatedArea":"Marketing","icon":"AD","status":"C"},{"activityCategoryId":"f8f862c4-fa5c-49a7-aea3-9664d085fbe7","name":"Sales","relatedArea":"Sales","icon":"SALES","status":"C"}].map(e => new ActivityCategory(e));
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'activityCategory',
    dataArea: 'Firm Settings',
    table: 'ACTIVITY_CATEGORY',
    // Keep deleted rows in the client store and backup (historical references). OWA-68
    includeDeletedInResults: true,
    comment: 'A top-level grouping that organises activity types (the individual billable or administrative actions logged against tasks and cases). Each category carries an optional billing-rate override and a classification (relatedArea) that maps it to a business area such as Client, Sales, or Administrative, which enables area-specific functionality elsewhere in the product. System-seeded categories include Administrative, Client, Financials, Human Resources, Marketing, and Sales; firms may add their own.',
    fields: {
        activityCategoryId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique ID for activity category'
        },

        // Name to show in the drop-down
        name: {type: 'string', required: true, comment: 'Name to show in the drop-down'},

        // Specific rate
        rate: {type: 'money', comment: 'Override the default rate for this category of activity'},

        // Does this rate scale with the negotiated rate?  This is handy if there is no paralegal or secretary
        // and the work is administrative
        scaled: {type: 'boolean', comment: 'Does this rate scale with the negotiated rate?'},

        // An icon to associate (ex. 'ACTIVITY')
        icon: {type: 'string', comment: `The icon name for this category (e.g. 'BUSINESS', 'CASE'), used to look up the icon to display`},

        relatedArea: {type: 'string', comment: 'Related area, e.g. sales or client'}
    },
    entries: [
        {activityCategoryId: 'ca1a6abc-2f87-4d4a-9e2a-ea36c944d0c6', name: 'Administrative', relatedArea: 'Administrative', icon: 'BUSINESS'},
        {activityCategoryId: 'a8415c01-8d32-4620-bdc1-6832c6227c25', name: 'Client', relatedArea: 'Client', icon: 'CASE'},
        {activityCategoryId: '0bc3ad94-8786-425f-bcbc-2bad281c0ad6', name: 'Financials', relatedArea: 'Financials', icon: 'CHART'},
        {activityCategoryId: 'fabc9370-8ead-4c82-9a4d-a37f9a692d92', name: 'Human Resources', relatedArea: 'Human Resources', icon: 'USER'},
        {activityCategoryId: '038bd87f-2d35-431e-b5c8-7a31cf31a9f6', name: 'Marketing', relatedArea: 'Marketing', icon: 'AD'},
        {activityCategoryId: 'f8f862c4-fa5c-49a7-aea3-9664d085fbe7', name: 'Sales', relatedArea: 'Sales', icon: 'SALES'}
    ]
});
    }
}
export default ActivityCategory;
